import useAccountUser from 'selectors/users/use-account-user';

export default function useCourseRole(courseId) {
  return useAccountUser(courseId)?.role;
}
